var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VButtonIcon',_vm._g({directives:[{name:"tooltip",rawName:"v-tooltip",value:({
        content: _vm.$t('delete'),
        placement: 'bottom',
    }),expression:"{\n        content: $t('delete'),\n        placement: 'bottom',\n    }"}],attrs:{"color":"red"}},_vm.$listeners),[_c('TrashSVG')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }